import { useState, useEffect } from 'react';

const useTimer = ({ expiresIn, setIsTerminated = null }) => {
  // states
  const [min, setMin] = useState(Math.floor(expiresIn / 60));
  const [sec, setSec] = useState(expiresIn - min * 60);
  const [timeLeft, setTimeLeft] = useState(expiresIn);
  const [timerRunning, setTimerRunning] = useState(false);

  const resetTimer = () => {
    setTimeLeft(expiresIn);
    setMin(Math.floor(expiresIn / 60));
    setSec(expiresIn - min * 60);
  };

  const startTimer = () => {
    resetTimer();
    setTimerRunning(true);
    if (setIsTerminated) setIsTerminated(false);
  };

  const stopTimer = () => {
    setTimerRunning(false);
    if (setIsTerminated) setIsTerminated(true);
  };

  const formatTime = (t) => (t < 10 ? `0${t}` : t);

  useEffect(() => {
    let interval;

    if (timerRunning) {
      // eslint-disable-next-line consistent-return
      interval = setInterval(() => {
        const m = Math.floor((timeLeft - 1) / 60);
        const s = (timeLeft - 1) - m * 60;

        setMin(m);
        setSec(s);
        if (m <= 0 && s <= 0) {
          setTimeLeft(0);
          setTimerRunning(false);
          if (setIsTerminated) setIsTerminated(true);
          return () => clearInterval(interval);
        }

        setTimeLeft((t) => t - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timerRunning, timeLeft]);

  return {
    formattedTime: `${formatTime(min)}:${formatTime(sec)}`,
    timeLeft,
    startTimer,
    stopTimer,
  };
};

export default useTimer;
